import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { storesService } from '@/services/storesService'

export const useStoresStore = defineStore('stores', () => {
  // State
  const stores = ref([])
  const loading = ref(false)
  const error = ref(null)

  // Getters
  const getStoreBySlug = computed(() => {
    return (slug) => stores.value.find(store => store.slug === slug)
  })

  const amazonStores = computed(() => {
    return stores.value.filter(store => store.marketplace === 'Amazon')
  })

  const ebayStores = computed(() => {
    return stores.value.filter(store => store.marketplace === 'eBay')
  })

  const walmartStores = computed(() => {
    return stores.value.filter(store => store.marketplace === 'Walmart')
  })

  // Actions
  const fetchStores = async () => {
    if (stores.value.length > 0) return // Don't fetch if we already have stores

    loading.value = true
    error.value = null

    try {
      stores.value = await storesService.getAllStores()
    } catch (err) {
      console.error('Error fetching stores:', err)
      error.value = 'Failed to load stores'
    } finally {
      loading.value = false
    }
  }

  const refreshStores = async () => {
    loading.value = true
    error.value = null

    try {
      stores.value = await storesService.getAllStores()
    } catch (err) {
      console.error('Error refreshing stores:', err)
      error.value = 'Failed to refresh stores'
    } finally {
      loading.value = false
    }
  }

  return {
    // State
    stores,
    loading,
    error,
    
    // Getters
    getStoreBySlug,
    amazonStores,
    ebayStores,
    walmartStores,
    
    // Actions
    fetchStores,
    refreshStores
  }
}) 